<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>TDS Overrides</div>
      <template slot="icon" v-if="!showIntro">
        <div class="row-container">
          <div class="showIntro" v-on:click="goToIntro">
            <img class="imgClass" src="@/assets/questionmark.png" />
          </div>
        </div>
      </template>
    </tl-header>
    <div>
      <div class="row-container center">
        <div class="company-info" v-show="showIntro">
          <img class="image" src="@/assets/team.svg" />
          <div v-on:click="hideIntro">
            <img class="closeImage" src="@/assets/close.png" />
          </div>
          <div class="fontStyle">
            <span>
              The monthly TDS can be overridden in special cases.
              The amount input here will override the monthly TDS and the
              excess/remaining amount will be adjusted in coming month.
            </span>
          </div>
        </div>
      </div>
      <div>
        <tds />
      </div>
    </div>
  </div>
</template>

<script>
import Tds from "./tds.vue";
export default {
  name: "tdsIntro",
  components: { Tds },
  data() {
    return {
      showIntro: true
    };
  },
  methods: {
    /** to hide the intro screen if paygroups available */
    hideIntro() {
      this.showIntro = false;
    },
    /** to show the intro screen if paygroups are not available */
    goToIntro() {
      this.showIntro = true;
    },
    /** Navigation */
    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      });
    },
    next() {}
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/introPage.scss";
.line {
  border-bottom: 1px solid #34c0be;
  flex-grow: 1;
  margin-top: 15%;
}
.btnGrp {
  float: right;
}
</style>
